import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

interface SubscribeButtonProps {
    onClick?: () => void;
}

const SubscribeButton: React.FC<SubscribeButtonProps> = ({ onClick }) => {
    const t = useTranslations("messages");

    return (
        <Button
            className="!bg-ciBlue_900 flex !gap-[6px] md:!gap-[8px] items-center justify-center !px-[12px] md:!px-[16px] !py-[6px] md:!py-[8px] !rounded-[4px] report-subscribe-notice-button"
            onClick={onClick}
            sx={{
                width: '100%',
                maxWidth: '100%',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                '&:hover': {
                    backgroundColor: '#0056b3 !important',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                },
            }}
        >
            <Box
                className="flex flex-col items-center justify-center text-center"
                sx={{
                    maxWidth: '100%',
                    overflowWrap: 'break-word',
                }}
            >
                {/* <Typography
                    variant="body1"
                    className='!text-white !font-[Montserrat,sans-serif] !font-[500] !text-[12px] md:!text-[14px] !leading-[20px] md:!leading-[24px] !tracking-[0px]'
                    translation-key="report_subscribe_notice_button_subtitle"
                    sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center',
                    }}
                >
                    {t("report_subscribe_notice_button_subtitle")}
                </Typography> */}
                <Typography
                    variant="h6"
                    className='!text-white !font-[Montserrat,sans-serif] !font-[600] !text-[16px] md:!text-[18px] !leading-[20px] md:!leading-[24px] !tracking-[0px]'
                    translation-key="report_subscribe_notice_button_title"
                    sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center',
                    }}
                >
                    {t("report_subscribe_notice_button_title")}
                </Typography>
            </Box>
        </Button>
    );
};

export default SubscribeButton;